import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Crown, HeartHandshake } from 'lucide-react';
import { LogoPlate } from './Brand';

const GROUPS = [
  { key: 'explore', links: [
    { to: '/', key: 'home' }, { to: '/regles', key: 'rules' }, { to: '/premium', key: 'premium' },
  ] },
  { key: 'community', links: [
    { to: '/amis', key: 'friends' }, { to: '/amis/parrainage', key: 'referral' }, { to: 'https://discord.gg/E56FvJArpN', key: 'discord' },
  ] },
  { key: 'information', links: [
    { to: '/conditions', key: 'terms' }, { to: '/conditions-vente', key: 'sales' },
    { to: '/confidentialite', key: 'privacy' }, { to: '/mentions-legales', key: 'notice' }, { to: '/cookies', key: 'cookies' },
    { to: 'mailto:contact.edwyn@gmail.com', key: 'contact' },
  ] },
] as const;

export function SiteFooter() {
  const { t } = useTranslation();
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__top">
        <Link to="/" className="site-footer__brand" aria-label={t('nav.homeAria')}><LogoPlate size="sm" adaptive /><span><strong translate="no">ANIDEX</strong><span>{t('footer.tagline')}</span></span></Link>
        <Link to="/premium" className="site-footer__support"><HeartHandshake size={24} aria-hidden="true" /><span><strong>{t('footer.support')}</strong><span>{t('footer.supportNote')}</span></span><Crown size={18} aria-hidden="true" /></Link>
      </div>
      <div className="site-footer__links">
        {GROUPS.map((group) => <nav key={group.key} aria-label={t(`footer.${group.key}`)}>
          <h3>{t(`footer.${group.key}`)}</h3>
          {group.links.map((link) => link.to.startsWith('/') ? (
            <Link key={link.to} to={link.to}>{t(`footer.${link.key}`)}</Link>
          ) : link.to.startsWith('mailto:') ? (
            <a key={link.to} href={link.to}>{t(`footer.${link.key}`)}</a>
          ) : (
            <a key={link.to} href={link.to} target="_blank" rel="noopener noreferrer">{t(`footer.${link.key}`)}</a>
          ))}
        </nav>)}
      </div>
      <div className="site-footer__bottom"><p><span className="site-footer__dot" aria-hidden="true" />{t('footer.note')}</p><p>{t('footer.independent')}</p><p>{t('footer.copyright', { year: new Date().getFullYear() })}</p></div>
    </footer>
  );
}
